export default {
  // this.getTranslate('我们@来@',{name:this.includeTypes,type:'66666'})
getTranslate(str,param){
  let index =  str.indexOf('XXX')
  let  num = 0;
    num++
    index=str.indexOf('XXX',index + 1)
    for(let key in param){
      let itm = param[key]
      let reg = new RegExp("XXX",'i')
            str = str.replace(reg,itm)
    }
    return str;
     
 
}
}

